export default function Footer({}){
    return (
        <div className="flex px-2 py-1 text-sm bg-gray-100 text-gray-600">
            <div className="flex-grow"></div>
            <p>© <a href="https://sensingplaces.com" target="_blank" rel="nofollow" className="hover:underline">Sensing Places LLC</a> {new Date().getFullYear()}</p>
        </div>
    )
}